import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
// Stimulsoft needs to importet from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer'
// import { Stimulsoft } from 'stimulsoft-reports-js' breaks Alberta
import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer';

import { MobileAccessibilityService } from '../../services/mobile-accessibility-service';

@Component({
  selector: 'report-modal',
  templateUrl: 'report-modal.html',
  styleUrls: ['report-modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportModal implements OnInit {
  @Input()
  public report: any;
  @Input()
  public name = 'Dokument';
  @Input()
  public showSaveButton = false;
  public readonly isIOs: boolean;

  private _viewer: Stimulsoft.Viewer.StiViewer;
  private readonly isCordova: boolean;

  constructor(
    private _platform: Platform,
    private _modalController: ModalController,
    private _mobileAccessibility: MobileAccessibilityService
  ) {
    this.isCordova = this._platform.is('hybrid');
    this.isIOs = this._platform.is('ios');
    Stimulsoft.Base.StiLicense.key = environment.stimulsoftLicense;
  }

  ngOnInit(): void {
    const options = new Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.fullScreenMode = true;
    options.appearance.allowTouchZoom = true;
    options.toolbar.showDesignButton = false;
    options.toolbar.showOpenButton = false;
    options.toolbar.showPrintButton = false;
    options.toolbar.showSaveButton = this.showSaveButton;
    options.appearance.htmlRenderMode = Stimulsoft.Report.Export.StiHtmlExportMode.Div;

    if (this.isCordova) {
      options.toolbar.showPinToolbarButton = false;
      options.toolbar.showBookmarksButton = false;
      options.toolbar.showCurrentPageControl = false;
      options.toolbar.showAboutButton = false;
      options.toolbar.showParametersButton = false;
      options.toolbar.showFullScreenButton = false;
      options.toolbar.showZoomButton = false;
      options.toolbar.showResourcesButton = false;
    }

    this._viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
    this.report.reportName = this.name;
    this._viewer.report = this.report;
    this._viewer.renderHtml('viewerContent');
  }

  ionViewDidEnter() {
    if (this._platform.is('android')) {
      this._mobileAccessibility.usePreferredTextZoom(false);
    }
  }
  ionViewDidLeave() {
    if (this._platform.is('android')) {
      this._mobileAccessibility.usePreferredTextZoom(true);
    }
  }

  public cancel() {
    this._modalController.dismiss().catch(error => console.error(error));
  }
}
